import Button from '@admin/components/button'
import Token from '@admin/components/token'
import List from '@admin/components/list'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'
import Time from './time'

class TimesField extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.array,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    onReady: PropTypes.func,
    onValid: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    times: []
  }

  _handleAdd = this._handleAdd.bind(this)
  _handleCreate = this._handleCreate.bind(this)
  _handleValidate = this._handleValidate.bind(this)

  render() {
    return (
      <>
        <List { ...this._getList() } />
        <Button { ...this._getAdd() } />
      </>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(defaultValue) this.setState({
      times: defaultValue
    })
    this.props.onReady(this._handleValidate)
  }

  componentDidUpdate(prevProps, prevState) {
    const { times } = this.state
    if(!_.isEqual(times, prevState.times)) {
      this.props.onChange(times)
    }
  }

  _getAdd() {
    return {
      label: '+ t(add time)',
      className: 'link',
      handler: this._handleAdd
    }
  }

  _getDescription(time) {
    return [
      moment(`2020-01-01 ${time.start_time}`).format('h:mmA'),
      moment(`2020-01-01 ${time.end_time}`).format('h:mmA')
    ].join('-')
  }

  _getEdit(time, index) {
    return {
      time: time,
      mode: 'edit',
      onDone: this._handleUpdate.bind(this, index)
    }
  }

  _getList() {
    const { times } = this.state
    return {
      actions: (item, index) => [
        {
          svg: 'pencil',
          handler: this._handleEdit.bind(this, item, index)
        },
        {
          svg: 'x',
          confirm: 't(Are you sure you want to remove this time?)',
          handler: this._handleRemove.bind(this, index)
        }
      ],
      items: times,
      empty: <Token text='t(You have not yet added any times)' />,
      format: (time) => <Token text={ this._getDescription(time) } />
    }
  }

  _getNew() {
    return {
      mode: 'new',
      onDone: this._handleCreate
    }
  }

  _handleAdd() {
    this.context.form.push(Time, this._getNew())
  }

  _handleCreate(time) {
    const { times } = this.state
    this.setState({
      times: [
        ...times,
        time
      ]
    })
  }

  _handleEdit(time, index) {
    this.context.form.push(Time, this._getEdit(index))
  }

  _handleRemove(index) {
    const { times } = this.state
    this.setState({
      times: times.filter((time, i) => {
        return i !== index
      })
    })
  }

  _handleUpdate(i, updated) {
    const { times } = this.state
    this.setState({
      times: times.map((time, index) => {
        return index === i ? updated : time
      })
    })
  }

  _handleValidate() {
    const { times } = this.state
    const { required, onValid } = this.props
    if(required && (!times || times.length === 0)) {
      return onValid(null, ['You must add at least 1 time'])
    }
    onValid(times)
  }

}

export default TimesField
